$(function() {

    $('#mobile-panel').scotchPanel({
        containerSelector: 'body',
        direction: 'left',
        duration: 300,
        transition: 'ease',
        clickSelector: '.toggle-panel',
        distanceX: '80%',
        enableEscapeKey: true
    });

});